// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.desc-item[data-v-5414b34e] {\n  margin-bottom: 30px;\n}\n.desc-item[data-v-5414b34e]:last-child {\n  margin-bottom: 0px;\n}\n.title[data-v-5414b34e] {\n  color: #797979;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n.text[data-v-5414b34e] {\n  margin-bottom: 25px;\n  color: #929292;\n  font-size: 13px;\n  line-height: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
